import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'

import SidebarDefault from './SidebarDefault'
import SidebarSettings from './SidebarSettings'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'

import './styles.scss'

@inject('app')
@observer
class Sidebar extends Component {
  static propTypes = {
    app: PropTypes.instanceOf(AppModel),
  }

  static defaultProps = {
    app: AppModelNULL,
  }

  render() {
    const type = this.props.app.editingSettings.type
    const showSettings = !(type === 'NULL')

    return (
      <aside 
        className={`site-sidebar${this.props.app.hasWizard ? ' with-wizard' : ''}`} 
        style={{ 
          width: this.props.app.editingSettings.isCroppingFullWidth ? '80vw' : '380px',
          backgroundColor: 'white',
        }}
      >
        <div className="default-sidebar-content">
          <Choose>
            <When condition={showSettings}>
              <SidebarSettings model={this.props.app.editingSettings} />
            </When>
            <When condition={!showSettings}>
              <SidebarDefault />
            </When>
          </Choose>
        </div>
      </aside>
    )
  }
}

export default Sidebar
